import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { KeySuppliers } from './KeySuppliers';
import { keySuppliersCharacterizeValues, PARTNERS_NAMES, prefix } from './utils/form';

export const PartnersSection: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.BUSINESS_OPERATIONS,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_BUSINESS_OPERATIONS.LOCATION_AND_PREMISES,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('businessOperations.title')}
          badgeText={t('businessOperations.partners.title')}
          section={FOR_BANK_SECTIONS.BUSINESS_OPERATIONS}
        />
      </FormSectionCard>
      {/* 6.6.1 */}
      <FormSectionCard disabled={!canAccess} title={t('businessOperations.partners.keySuppliers.title')} collapsible>
        <FieldArrayComponent
          name={concatWithDot(prefix, PARTNERS_NAMES.KEY_SUPPLIERS)}
          initialItem={keySuppliersCharacterizeValues}
          buttonText={t('businessOperations.partners.keySuppliers.buttonText')}
          disabled={!canAccess}
        >
          {(namePrefix) => <KeySuppliers name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
      {/* 6.6.2 */}

      <FormSectionCard
        disabled={!canAccess}
        title={t('businessOperations.partners.criteria')}
        aiFieldName={concatWithDot(prefix, PARTNERS_NAMES.CRITERIA)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, PARTNERS_NAMES.CRITERIA)}
          name={concatWithDot(prefix, PARTNERS_NAMES.CRITERIA)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
